// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Accordion/Actions.story.tsx with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Accordion, AccordionItem, Link, Button, ButtonGroup, view, css } from '@sail/ui';
import { PanelExample } from './PanelExample';
const titles = ['Example using a link', 'Example using a button', 'Multiple buttons are cool too'];
const actionExamples = [<Link onPress={() => null}>Edit</Link>, <Button onPress={() => null}>Configure</Button>, <ButtonGroup>
    <Button onPress={() => null}>Action 1</Button>
    <Button onPress={() => null}>Action 2</Button>
  </ButtonGroup>];
export const Actions = () => {
  return <view.div css={{
    background: 'surface',
    minWidth: css.value('500px')
  }}>
      <Accordion>
        {[0, 1, 2].map(i => <AccordionItem title={titles[i]} subtitle={i > 2 && 'An optional subtitle can be provided.'} actions={actionExamples[i]} key={i}>
            <PanelExample />
          </AccordionItem>)}
      </Accordion>
    </view.div>;
};